// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
  background: #fff;
  --aimdFlowPrimaryColor : #72D8DA;
  --aimdFlowSecondaryDarkTextColor : #35C6C9;
  --aimdLinearGradientBtnColor : linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%);


}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Customize the scrollbar width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 5px;
  height: auto;
}

/* Customize the scrollbar track color */

Expand Down ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Customize the scrollbar thumb color */
::-webkit-scrollbar-thumb {
  background: #f1f1f1;
}

/* Customize the scrollbar thumb on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Hides up/down arrows for textfield type number.
   Works for Chrome, Safari, Edge, Opera
 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/*
  Hides up/down arrows for textfield type number.
  Works for Firefox
*/
input[type='number'] {
  -moz-appearance: textfield;
}

/* making the poppers have the same border radius */
.MuiPickersPopper-paper,
.MuiPopover-paper {
  border-radius: 10px !important;
}

/* RESULTS PAGE CSS */

.results-page-wrapper {
  height: 100% !important;
}

.results-page-wrapper .btn-shadow {
  /* box-shadow:
    0px 35px 35px 0px rgba(0, 0, 0, 0.09),
    0px 9px 19px 0px rgba(0, 0, 0, 0.1); */
  /* box-shadow: 0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.06); */
  box-shadow:
    0px 35px 35px 0px rgba(0, 0, 0, 0.01),
    0px 9px 19px 0px rgba(0, 0, 0, 0.05);
}

.results-page-wrapper .result-page-card {
  width: 390px;
  /* background-color: #fff !important; */
  padding-bottom: 10px;
}
.results-page-wrapper .result-page-card .top-header {
  min-height: 80px;
}

.results-page-wrapper .result-page-card .result-component {
  position: relative;
  width: 100%;
  min-height: 449px;
  border-radius: 15px;
  margin-top: 2rem;
  max-height: 450px;
}

.results-page-wrapper .result-page-card .result-component.large {
  min-height: 380px; /* Keep large cards same height */
}

.results-page-wrapper .result-page-card .result-component > * {
  flex-shrink: 0;
}


.results-page-wrapper .result-page-card .card-shadow {
  box-shadow: 0 28px 19px rgba(0, 0, 0, 0.07);
  background: #e4e3e3;
}

.results-page-wrapper .result-page-card .card-gradient {
  background: linear-gradient(180deg, #fcfafa 0%, #e4e3e3 100%);
  box-shadow: 0 28px 19px rgba(0, 0, 0, 0.07);
}

.results-page-wrapper .result-page-card .result-logo {
  position: absolute;
  bottom: 18px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  padding-top: 20px;
  margin-top: auto;
}
.results-page-wrapper .result-page-card .result-logo img {
  width: 100px !important;
  position: relative;
  top: 10px;
  height: auto;
}

/* apply to lg deivce partner footer aimd logo  */
.results-page-wrapper .result-page-card .result-logo img.custom-main-logo-for-md {
  width: 60px !important;
  position: relative;
  top: 10px;
  height: auto;
}

/* apply to lg deivce partner footer partner logo  */
.results-page-wrapper .result-page-card .result-logo img.custom-main-logo {
  width: 60px !important;
  top: 0px;
  height: auto;
}

.result-component .progress-item {
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;
}

.result-component .progress-item .prograss-bar {
  width: 82%;
}

/* Utilities Classes */

.analysis-link {
  display: inline-block;
  width: 100%;
  text-align: center;
}

.analysis-link:hover .btn-txt {
  color: #000 !important;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.MuiLinearProgress-root {
  background-color: #fff !important;
}

.custom-link-tag {
  color: #31a6ee;
  padding-left: 5px;
  padding-right: 5px;
  text-decoration-line: underline;
}

/* Icons */

.s-icon {
  width: 17px;
  height: 17px;
}

/* .top-header {
  min-height: 100px;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-around !important;
  border: 2px solid red;
} */

/* Images */

/* .result-logo {
  position: absolute;
  bottom: 0;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center;
  width: 81px;
  height: 81px;
  border: 2px solid red;
} */

/* CSS Slider container */
.sliders-container {
  max-width: 490px;
  position: relative;
  margin: auto;
  z-index: 900 !important;
}

.sliders-container .controls-list {
  position: absolute;
  top: 10.44rem;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1000 !important;
}

/* Hide the images by default  */
.sliderItem {
  display: none;
}

/* Adding fading animation */
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

@keyframes fade {
  from {
    opacity: 0.4;
  }

  to {
    opacity: 1;
  }
}

/* handle margin top for card when below 1200 and above 500 */
@media (min-width: 500px) and (max-width: 1200px) {
  .results-page-wrapper .result-page-card .result-component {
    margin-top: 40px;
  }
}

/* Responiveness for Result card */
/* @media (max-width: 485px) */
@media (max-width: 500px) {
  .results-page-wrapper {
    width: 100%;
    padding: 0;
    overflow-x: hidden;
  }

  .sliders-container {
    overflow-x: hidden;
  }

  .results-page-wrapper .result-page-card {
    width: 100%;
    overflow-x: hidden;
  }

  .result-card-footer img {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }

  .results-page-wrapper .result-page-card .top-header {
    /* min-height: 80px; */
    min-height: 64px;
  }

  .results-page-wrapper .result-page-card .result-component {
    /* min-height: 344px; */
    min-height: 280px;
    margin-top: 32px;
  }

  /* When result-component-org is added */
  .results-page-wrapper .result-page-card .result-component.result-component-org {
    min-height: 300px;
    margin-top: 36px;
  }
  .results-page-wrapper .result-page-card .result-logo img {
    width: 70px !important;
    height: auto;
  }
  .results-page-wrapper .result-page-card .result-logo img.custom-main-logo {
    width: 50px !important;
    top: 0px;
    height: auto;
  }
}

/* Analysis Page */

.analysis-page-wrapper {
  min-height: 100vh;
  min-width: 100%;
  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);
}

.large-analysis-page-wrapper {
  min-height: 100vh;
  min-width: 100%;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);
}

.analysis-page-wrapper .custom-ranges {
  min-height: 20px;
}

.c-range {
  height: 9px;
}

.analysis-page-wrapper .low-range {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #f34848;
}

.optimal-range {
  background-color: #a6e177;
}

.normal-range {
  background-color: #50ba47;
}

.elevated-range {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #f2d53a;
}

.range-txt {
  color: #000;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 8px;
  /* 100% */
}

.range-point {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #a6e177;
}

.range-box {
  position: relative;
}

.range-point {
  position: absolute;
  top: -4px;
}

.analysis-page-wrapper .analysis-page-card {
  max-width: 350px;
  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);
  /* background-color: #fff !important; */
  overflow: hidden;
}

.large-analysis-slider .swiper {
  min-width: 65%;
  margin-top: 30px !important;
}

.large-analysis-page-wrapper .swiper-pagination {
  display: flex !important;
  justify-content: space-between !important;
  min-width: 150% !important;
  left: -12rem !important;
  height: 50px;
  top: 0rem !important;
  z-index: 1 !important;
  margin-bottom: 3rem !important;
}

.large-analysis-page-wrapper .product-card {
  /* box-shadow:
    0px 20px 6px 0px rgba(0, 0, 0, 0),
    0px 14px 5px 0px rgba(0, 0, 0, 0.01),
    0px 8px 5px 0px rgba(0, 0, 0, 0.05),
    0px 37px 37px 0px rgba(0, 0, 0, 0.09),
    0px 9px 20px 0px rgba(0, 0, 0, 0.1); */

  box-shadow:
    0px 12px 30px 6px rgba(0, 0, 0, 0.05),
    0px 18px 40px 10px rgba(0, 0, 0, 0.06);
}

.large-analysis-page-wrapper .swiper-pagination-bullet {
  border-radius: 0 !important;
  width: 100% !important;
  height: 3.33px !important;
}

.large-analysis-page-wrapper .swiper-pagination-bullet:hover,
.large-analysis-page-wrapper .swiper-pagination-bullet-active {
  background: #717171 !important;
}

/*
.large-analysis-slider .swiper-button-next {
  margin-right: -280px !important;
  z-index: 10000 !important;
}

.large-analysis-slider .swiper-button-prev {
  margin-left: -280px !important;
  z-index: 10000 !important;
}

.large-analysis-slider .swiper-button-next,
.large-analysis-slider .swiper-button-prev {
  width: 26px !important;
  height: 26px !important;
  border-radius: 50%;
  border: 1px solid #bbb !important;
  color: #31A6EE !important;
  background-color: #dadada;
}

.large-analysis-slider .swiper-button-next:after,
.large-analysis-slider .swiper-button-prev:after {
  font-size: 14px !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
} */

.analysis-page-wrapper .analysis-page-card .top-header {
  min-height: 108px;
}

.product-img-box img {
  width: 150px;
  height: 150px;
}

.analysis-slider .slider-box {
  border-radius: 15px;
  padding: 4px 10px;
  background: linear-gradient(180deg, #fcfcfc 0%, #e4e3e3 100%);
  box-shadow:
    0px 230px 64px 0px rgba(0, 0, 0, 0),
    0px 147px 59px 0px rgba(0, 0, 0, 0.01),
    0px 83px 50px 0px rgba(0, 0, 0, 0.05),
    0px 37px 37px 0px rgba(0, 0, 0, 0.09),
    0px 9px 20px 0px rgba(0, 0, 0, 0.1);
}

/* Product Slider */
.analysis-page-wrapper .product-slider .product-card {
  border-radius: 15px;
  padding: 20px;
  max-width: 280px;
  margin: 30px;
  background: #fff;
  box-shadow: 0px 9px 20px 0px rgba(0, 0, 0, 0.10);
}
/* Discord Card */

.analysis-page-wrapper .discord-card {
  border-radius: 15px;
  background: linear-gradient(180deg, #fcfcfc 0%, #e4e3e3 100%);
  box-shadow:
    0px 230px 64px 0px rgba(0, 0, 0, 0),
    0px 147px 59px 0px rgba(0, 0, 0, 0.01),
    0px 83px 50px 0px rgba(0, 0, 0, 0.05),
    0px 37px 37px 0px rgba(0, 0, 0, 0.09),
    0px 9px 20px 0px rgba(0, 0, 0, 0.1);
}

/* Utility Classes */

.linear-txt {
  background: linear-gradient(90deg, #72d8da 3.74%, #a6e177 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.product-slider .swiper-pagination {
  display: none !important;
}

.large-product-slider .productSwiper {
  min-width: 85%;
  margin-top: 50px;
  margin-bottom: 50px;
}

.dummy-product-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 260px;
  margin-top: 10px;
  margin-left: 8px;
  height: 148px;
  border-radius: 15px;
  color: gray !important;
  background: #f8f8f8;
  box-shadow:
    0px 230px 64px 0px rgba(0, 0, 0, 0),
    0px 147px 59px 0px rgba(0, 0, 0, 0.01),
    0px 83px 50px 0px rgba(0, 0, 0, 0.05),
    0px 37px 37px 0px rgba(0, 0, 0, 0.09),
    0px 9px 20px 0px rgba(0, 0, 0, 0.1);
}

/* Responsive */

@media (max-width: 435px) {
  .analysis-page-wrapper {
    width: 100%;
    min-height: inherit !important;
    display: block !important;
    align-items: inherit !important;
    flex-direction: inherit !important;
    justify-content: inherit !important;
  }

  .analysis-page-wrapper .analysis-page-card {
    width: 90% !important;
    margin-left: auto;
    margin-right: auto;
    padding-left: 2px !important;
    padding-right: 2px;
  }

  .swiper {
    width: 100%;
  }

  .social-share-link button {
    font-size: 24px !important;
    min-width: 50px !important;
    min-height: 50px !important;
  }
}

/* Paddings */
.pb-3px {
  padding-bottom: 3px;
}

.pt-3px {
  padding-top: 3px;
}
/* Border Radius */

.b-tb-r-radius-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.b-tb-l-radius-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.b-tb-l-radius {
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.b-tb-r-radius {
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.analysis-card-shadow {
  /* box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.25); */
  /* box-shadow: 0 10px 19px rgba(0, 0, 0, 0.20); */
  box-shadow:
    0px 12px 30px 6px rgba(0, 0, 0, 0.05),
    0px 18px 40px 10px rgba(0, 0, 0, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,oFAAoF;;;AAGtF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA,wCAAwC;;AAExC;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;;;CAGC;AACD;EACE,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;;EAEE,8BAA8B;AAChC;;AAEA,qBAAqB;;AAErB;EACE,uBAAuB;AACzB;;AAEA;EACE;;0CAEwC;EACxC,+FAA+F;EAC/F;;wCAEsC;AACxC;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;;AAEtB;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,UAAU;;AAEV;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;GAOG;;AAEH,WAAW;;AAEX;;;;;;;;;GASG;;AAEH,yBAAyB;AACzB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;AAClC,8BAA8B;AAC9B;EACE;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;AACF;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;EACjB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,+EAA+E;AACjF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+EAA+E;EAC/E,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE;;;;;0CAKwC;;EAExC;;0CAEwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D;;;;;uCAKqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;AACA,iBAAiB;;AAEjB;EACE,mBAAmB;EACnB,6DAA6D;EAC7D;;;;;uCAKqC;AACvC;;AAEA,oBAAoB;;AAEpB;EACE,+DAA+D;EAC/D,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB;;;;;uCAKqC;AACvC;;AAEA,eAAe;;AAEf;EACE;IACE,WAAW;IACX,8BAA8B;IAC9B,yBAAyB;IACzB,+BAA+B;IAC/B,kCAAkC;IAClC,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA,kBAAkB;;AAElB;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;EACjD;;0CAEwC;AAC1C","sourcesContent":[".App {\n  text-align: center;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  --aimdFlowPrimaryColor : #72D8DA;\n  --aimdFlowSecondaryDarkTextColor : #35C6C9;\n  --aimdLinearGradientBtnColor : linear-gradient(92deg, #72D8DA 2.79%, #35C6C9 90.54%);\n\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Customize the scrollbar width */\n::-webkit-scrollbar {\n  width: 10px;\n  border-radius: 5px;\n  height: auto;\n}\n\n/* Customize the scrollbar track color */\n\nExpand Down ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Customize the scrollbar thumb color */\n::-webkit-scrollbar-thumb {\n  background: #f1f1f1;\n}\n\n/* Customize the scrollbar thumb on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Hides up/down arrows for textfield type number.\n   Works for Chrome, Safari, Edge, Opera\n */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/*\n  Hides up/down arrows for textfield type number.\n  Works for Firefox\n*/\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n/* making the poppers have the same border radius */\n.MuiPickersPopper-paper,\n.MuiPopover-paper {\n  border-radius: 10px !important;\n}\n\n/* RESULTS PAGE CSS */\n\n.results-page-wrapper {\n  height: 100% !important;\n}\n\n.results-page-wrapper .btn-shadow {\n  /* box-shadow:\n    0px 35px 35px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 19px 0px rgba(0, 0, 0, 0.1); */\n  /* box-shadow: 0px 12px 30px 6px rgba(0, 0, 0, 0.05), 0px 18px 40px 10px rgba(0, 0, 0, 0.06); */\n  box-shadow:\n    0px 35px 35px 0px rgba(0, 0, 0, 0.01),\n    0px 9px 19px 0px rgba(0, 0, 0, 0.05);\n}\n\n.results-page-wrapper .result-page-card {\n  width: 390px;\n  /* background-color: #fff !important; */\n  padding-bottom: 10px;\n}\n.results-page-wrapper .result-page-card .top-header {\n  min-height: 80px;\n}\n\n.results-page-wrapper .result-page-card .result-component {\n  position: relative;\n  width: 100%;\n  min-height: 449px;\n  border-radius: 15px;\n  margin-top: 2rem;\n  max-height: 450px;\n}\n\n.results-page-wrapper .result-page-card .result-component.large {\n  min-height: 380px; /* Keep large cards same height */\n}\n\n.results-page-wrapper .result-page-card .result-component > * {\n  flex-shrink: 0;\n}\n\n\n.results-page-wrapper .result-page-card .card-shadow {\n  box-shadow: 0 28px 19px rgba(0, 0, 0, 0.07);\n  background: #e4e3e3;\n}\n\n.results-page-wrapper .result-page-card .card-gradient {\n  background: linear-gradient(180deg, #fcfafa 0%, #e4e3e3 100%);\n  box-shadow: 0 28px 19px rgba(0, 0, 0, 0.07);\n}\n\n.results-page-wrapper .result-page-card .result-logo {\n  position: absolute;\n  bottom: 18px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  text-align: center;\n  padding-top: 20px;\n  margin-top: auto;\n}\n.results-page-wrapper .result-page-card .result-logo img {\n  width: 100px !important;\n  position: relative;\n  top: 10px;\n  height: auto;\n}\n\n/* apply to lg deivce partner footer aimd logo  */\n.results-page-wrapper .result-page-card .result-logo img.custom-main-logo-for-md {\n  width: 60px !important;\n  position: relative;\n  top: 10px;\n  height: auto;\n}\n\n/* apply to lg deivce partner footer partner logo  */\n.results-page-wrapper .result-page-card .result-logo img.custom-main-logo {\n  width: 60px !important;\n  top: 0px;\n  height: auto;\n}\n\n.result-component .progress-item {\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: space-between;\n}\n\n.result-component .progress-item .prograss-bar {\n  width: 82%;\n}\n\n/* Utilities Classes */\n\n.analysis-link {\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n}\n\n.analysis-link:hover .btn-txt {\n  color: #000 !important;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.MuiLinearProgress-root {\n  background-color: #fff !important;\n}\n\n.custom-link-tag {\n  color: #31a6ee;\n  padding-left: 5px;\n  padding-right: 5px;\n  text-decoration-line: underline;\n}\n\n/* Icons */\n\n.s-icon {\n  width: 17px;\n  height: 17px;\n}\n\n/* .top-header {\n  min-height: 100px;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: space-around !important;\n  border: 2px solid red;\n} */\n\n/* Images */\n\n/* .result-logo {\n  position: absolute;\n  bottom: 0;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  text-align: center;\n  width: 81px;\n  height: 81px;\n  border: 2px solid red;\n} */\n\n/* CSS Slider container */\n.sliders-container {\n  max-width: 490px;\n  position: relative;\n  margin: auto;\n  z-index: 900 !important;\n}\n\n.sliders-container .controls-list {\n  position: absolute;\n  top: 10.44rem;\n  left: 0;\n  right: 0;\n  text-align: center;\n  z-index: 1000 !important;\n}\n\n/* Hide the images by default  */\n.sliderItem {\n  display: none;\n}\n\n/* Adding fading animation */\n.fade {\n  animation-name: fade;\n  animation-duration: 1.5s;\n}\n\n@keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* handle margin top for card when below 1200 and above 500 */\n@media (min-width: 500px) and (max-width: 1200px) {\n  .results-page-wrapper .result-page-card .result-component {\n    margin-top: 40px;\n  }\n}\n\n/* Responiveness for Result card */\n/* @media (max-width: 485px) */\n@media (max-width: 500px) {\n  .results-page-wrapper {\n    width: 100%;\n    padding: 0;\n    overflow-x: hidden;\n  }\n\n  .sliders-container {\n    overflow-x: hidden;\n  }\n\n  .results-page-wrapper .result-page-card {\n    width: 100%;\n    overflow-x: hidden;\n  }\n\n  .result-card-footer img {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n  }\n\n  .results-page-wrapper .result-page-card .top-header {\n    /* min-height: 80px; */\n    min-height: 64px;\n  }\n\n  .results-page-wrapper .result-page-card .result-component {\n    /* min-height: 344px; */\n    min-height: 280px;\n    margin-top: 32px;\n  }\n\n  /* When result-component-org is added */\n  .results-page-wrapper .result-page-card .result-component.result-component-org {\n    min-height: 300px;\n    margin-top: 36px;\n  }\n  .results-page-wrapper .result-page-card .result-logo img {\n    width: 70px !important;\n    height: auto;\n  }\n  .results-page-wrapper .result-page-card .result-logo img.custom-main-logo {\n    width: 50px !important;\n    top: 0px;\n    height: auto;\n  }\n}\n\n/* Analysis Page */\n\n.analysis-page-wrapper {\n  min-height: 100vh;\n  min-width: 100%;\n  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);\n}\n\n.large-analysis-page-wrapper {\n  min-height: 100vh;\n  min-width: 100%;\n  overflow-x: hidden;\n  display: flex;\n  justify-content: center;\n  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);\n}\n\n.analysis-page-wrapper .custom-ranges {\n  min-height: 20px;\n}\n\n.c-range {\n  height: 9px;\n}\n\n.analysis-page-wrapper .low-range {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n  background-color: #f34848;\n}\n\n.optimal-range {\n  background-color: #a6e177;\n}\n\n.normal-range {\n  background-color: #50ba47;\n}\n\n.elevated-range {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n  background-color: #f2d53a;\n}\n\n.range-txt {\n  color: #000;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 8px;\n  /* 100% */\n}\n\n.range-point {\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: #fff;\n  border: 2px solid #a6e177;\n}\n\n.range-box {\n  position: relative;\n}\n\n.range-point {\n  position: absolute;\n  top: -4px;\n}\n\n.analysis-page-wrapper .analysis-page-card {\n  max-width: 350px;\n  background: linear-gradient(180deg, #FCFCFC 0%, rgba(227, 227, 227, 0.50) 100%);\n  /* background-color: #fff !important; */\n  overflow: hidden;\n}\n\n.large-analysis-slider .swiper {\n  min-width: 65%;\n  margin-top: 30px !important;\n}\n\n.large-analysis-page-wrapper .swiper-pagination {\n  display: flex !important;\n  justify-content: space-between !important;\n  min-width: 150% !important;\n  left: -12rem !important;\n  height: 50px;\n  top: 0rem !important;\n  z-index: 1 !important;\n  margin-bottom: 3rem !important;\n}\n\n.large-analysis-page-wrapper .product-card {\n  /* box-shadow:\n    0px 20px 6px 0px rgba(0, 0, 0, 0),\n    0px 14px 5px 0px rgba(0, 0, 0, 0.01),\n    0px 8px 5px 0px rgba(0, 0, 0, 0.05),\n    0px 37px 37px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 20px 0px rgba(0, 0, 0, 0.1); */\n\n  box-shadow:\n    0px 12px 30px 6px rgba(0, 0, 0, 0.05),\n    0px 18px 40px 10px rgba(0, 0, 0, 0.06);\n}\n\n.large-analysis-page-wrapper .swiper-pagination-bullet {\n  border-radius: 0 !important;\n  width: 100% !important;\n  height: 3.33px !important;\n}\n\n.large-analysis-page-wrapper .swiper-pagination-bullet:hover,\n.large-analysis-page-wrapper .swiper-pagination-bullet-active {\n  background: #717171 !important;\n}\n\n/*\n.large-analysis-slider .swiper-button-next {\n  margin-right: -280px !important;\n  z-index: 10000 !important;\n}\n\n.large-analysis-slider .swiper-button-prev {\n  margin-left: -280px !important;\n  z-index: 10000 !important;\n}\n\n.large-analysis-slider .swiper-button-next,\n.large-analysis-slider .swiper-button-prev {\n  width: 26px !important;\n  height: 26px !important;\n  border-radius: 50%;\n  border: 1px solid #bbb !important;\n  color: #31A6EE !important;\n  background-color: #dadada;\n}\n\n.large-analysis-slider .swiper-button-next:after,\n.large-analysis-slider .swiper-button-prev:after {\n  font-size: 14px !important;\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n} */\n\n.analysis-page-wrapper .analysis-page-card .top-header {\n  min-height: 108px;\n}\n\n.product-img-box img {\n  width: 150px;\n  height: 150px;\n}\n\n.analysis-slider .slider-box {\n  border-radius: 15px;\n  padding: 4px 10px;\n  background: linear-gradient(180deg, #fcfcfc 0%, #e4e3e3 100%);\n  box-shadow:\n    0px 230px 64px 0px rgba(0, 0, 0, 0),\n    0px 147px 59px 0px rgba(0, 0, 0, 0.01),\n    0px 83px 50px 0px rgba(0, 0, 0, 0.05),\n    0px 37px 37px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 20px 0px rgba(0, 0, 0, 0.1);\n}\n\n/* Product Slider */\n.analysis-page-wrapper .product-slider .product-card {\n  border-radius: 15px;\n  padding: 20px;\n  max-width: 280px;\n  margin: 30px;\n  background: #fff;\n  box-shadow: 0px 9px 20px 0px rgba(0, 0, 0, 0.10);\n}\n/* Discord Card */\n\n.analysis-page-wrapper .discord-card {\n  border-radius: 15px;\n  background: linear-gradient(180deg, #fcfcfc 0%, #e4e3e3 100%);\n  box-shadow:\n    0px 230px 64px 0px rgba(0, 0, 0, 0),\n    0px 147px 59px 0px rgba(0, 0, 0, 0.01),\n    0px 83px 50px 0px rgba(0, 0, 0, 0.05),\n    0px 37px 37px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 20px 0px rgba(0, 0, 0, 0.1);\n}\n\n/* Utility Classes */\n\n.linear-txt {\n  background: linear-gradient(90deg, #72d8da 3.74%, #a6e177 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.product-slider .swiper-pagination {\n  display: none !important;\n}\n\n.large-product-slider .productSwiper {\n  min-width: 85%;\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.dummy-product-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 260px;\n  margin-top: 10px;\n  margin-left: 8px;\n  height: 148px;\n  border-radius: 15px;\n  color: gray !important;\n  background: #f8f8f8;\n  box-shadow:\n    0px 230px 64px 0px rgba(0, 0, 0, 0),\n    0px 147px 59px 0px rgba(0, 0, 0, 0.01),\n    0px 83px 50px 0px rgba(0, 0, 0, 0.05),\n    0px 37px 37px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 20px 0px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive */\n\n@media (max-width: 435px) {\n  .analysis-page-wrapper {\n    width: 100%;\n    min-height: inherit !important;\n    display: block !important;\n    align-items: inherit !important;\n    flex-direction: inherit !important;\n    justify-content: inherit !important;\n  }\n\n  .analysis-page-wrapper .analysis-page-card {\n    width: 90% !important;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 2px !important;\n    padding-right: 2px;\n  }\n\n  .swiper {\n    width: 100%;\n  }\n\n  .social-share-link button {\n    font-size: 24px !important;\n    min-width: 50px !important;\n    min-height: 50px !important;\n  }\n}\n\n/* Paddings */\n.pb-3px {\n  padding-bottom: 3px;\n}\n\n.pt-3px {\n  padding-top: 3px;\n}\n/* Border Radius */\n\n.b-tb-r-radius-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.b-tb-l-radius-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.b-tb-l-radius {\n  border-top-left-radius: 10px !important;\n  border-bottom-left-radius: 10px !important;\n}\n\n.b-tb-r-radius {\n  border-top-right-radius: 10px !important;\n  border-bottom-right-radius: 10px !important;\n}\n\n.analysis-card-shadow {\n  /* box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.25); */\n  /* box-shadow: 0 10px 19px rgba(0, 0, 0, 0.20); */\n  box-shadow:\n    0px 12px 30px 6px rgba(0, 0, 0, 0.05),\n    0px 18px 40px 10px rgba(0, 0, 0, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
